// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"a1d228b5","455":"1b991356","525":"ccd6dd04","578":"98da6fca","712":"497060dd","770":"b7edeaa7","798":"c6ed31c6","815":"72456c83","883":"a5b9f98a","977":"459ae33c"}[chunkId] + ".chunk.js";
};